<!-- Loading state -->
@if (isLoading()) {
    <div class="loading-container">
        <div class="spinner"></div>
        <p>Cargando...</p>
    </div>
}

<!-- Error state -->
@if (error()) {
    <div class="error-container">
        <p class="error-message">{{ error() }}</p>
        <button (click)="clearError()" class="btn-dismiss">Cerrar</button>
    </div>
}

<!-- Main content -->
@if (showContent() && !isLoading()) {
    @if(isIberoPlace()) {
        <app-login-ibero></app-login-ibero>
    } @else {
        <div class="login-wrapper">
            @if (dataConfig(); as config) {
                <img 
                    class="logo-config" 
                    [ngSrc]="config.place.logo"  
                    [alt]="config.place.name"
                    width="146"
                    height="146"
                    priority
                >

                <p class="welcome poppins-extralight">Nos alegra tenerte de vuelta <br></p>
                
                <form (ngSubmit)="loginWithGoogle()" #loginForm="ngForm">
                    <div class="input-wrapper">
                        <img src="https://www.banderas-mundo.es/data/flags/w1600/co.png" alt="Bandera Colombia">
                        <select 
                            class="country-code" 
                            name="country-code" 
                            [ngModel]="phoneIndicative()"
                            (ngModelChange)="phoneIndicative.set($event)">
                            <option value="+57">+57</option>
                            <option value="+12">+12</option>
                            <option value="+65">+65</option>
                        </select>
                        <label for="tel">Número de teléfono</label>
                        <input 
                            type="tel" 
                            id="tel"
                            [ngModel]="phoneNumber()"
                            (ngModelChange)="phoneNumber.set($event)"
                            name="tel" 
                            placeholder="Escribe tu teléfono" 
                            pattern="[0-9]{10,15}"
                            required
                            [disabled]="isAuthenticating()">
                    </div>
                    
                    @if (!isFormValid() && phoneNumber()) {
                        <p class="validation-error">El número debe tener entre 10 y 15 dígitos</p>
                    }
                </form>

                <button 
                    type="button"
                    (click)="loginWithGoogle()" 
                    [disabled]="!canSubmit()"
                    class="btn-google">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" class="section-blue"
                            d="M18.28 9.88501C18.2804 9.27506 18.2262 8.66629 18.118 8.06601H9.742V11.506H14.529C14.4299 12.0501 14.2216 12.5685 13.9165 13.0299C13.6114 13.4912 13.2159 13.8858 12.754 14.19V16.422H15.628C16.5033 15.579 17.1917 14.5614 17.6486 13.4353C18.1054 12.3092 18.3206 11.0996 18.28 9.88501Z"
                            fill="currentColor" />
                        <path fill-rule="evenodd" clip-rule="evenodd" class="section-green"
                            d="M9.74103 18.577C11.905 18.6349 14.0094 17.864 15.624 16.422L12.753 14.188C12.0654 14.6292 11.2861 14.9076 10.4745 15.0019C9.66291 15.0962 8.84051 15.0039 8.07002 14.7321C7.29953 14.4603 6.60128 14.0161 6.02851 13.4334C5.45575 12.8508 5.02361 12.145 4.76503 11.37H1.79303V13.67C2.53221 15.1447 3.66708 16.3847 5.07073 17.2513C6.47437 18.1179 8.09143 18.5769 9.74103 18.577Z"
                            fill="currentColor" />
                        <path fill-rule="evenodd" clip-rule="evenodd" class="section-yellow"
                            d="M4.765 11.373C4.393 10.277 4.393 9.08895 4.765 7.99299V5.69299H1.794C1.17199 6.93251 0.848083 8.30017 0.848083 9.68699C0.848083 11.0738 1.17199 12.4415 1.794 13.681L4.765 11.373Z"
                            fill="currentColor" />
                        <path fill-rule="evenodd" clip-rule="evenodd" class="section-red"
                            d="M9.74103 4.32601C11.0053 4.30421 12.2271 4.78215 13.141 5.65601L15.692 3.10501C14.0821 1.59314 11.9494 0.763145 9.74103 0.789008C8.09213 0.788323 6.47554 1.24624 5.07195 2.11156C3.66836 2.97688 2.53308 4.21552 1.79303 5.68901L4.76403 7.98901C5.10634 6.93465 5.77063 6.01417 6.66343 5.35708C7.55622 4.7 8.63258 4.33939 9.74103 4.32601Z"
                            fill="currentColor" />
                    </svg>

                    @if (isAuthenticating()) {
                        <span>Autenticando...</span>
                    } @else {
                        <span>Continuar con Google</span>
                    }
                </button>

                <button class="btn-apple" disabled>
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.039 13.881C14.7797 14.485 14.4594 15.061 14.083 15.6C13.7288 16.1404 13.3156 16.6398 12.851 17.089C12.4294 17.5119 11.8646 17.7616 11.268 17.789C10.7625 17.7668 10.2659 17.648 9.80503 17.439C9.30775 17.2224 8.77324 17.1043 8.23103 17.091C7.67402 17.102 7.12434 17.2201 6.61203 17.439C6.16917 17.6389 5.69596 17.7633 5.21203 17.807C4.90776 17.8034 4.60738 17.7381 4.32908 17.6151C4.05079 17.492 3.80038 17.3137 3.59303 17.091C3.10816 16.6261 2.67589 16.1094 2.30403 15.55C1.72325 14.7174 1.26429 13.8062 0.941029 12.844C0.572785 11.8078 0.37948 10.7176 0.369029 9.61799C0.339491 8.53924 0.606887 7.47311 1.14203 6.53599C1.53196 5.85933 2.08996 5.29479 2.76203 4.89699C3.42442 4.50068 4.18018 4.28741 4.95203 4.27899C5.53493 4.31345 6.10775 4.44668 6.64603 4.67299C7.07492 4.86368 7.52666 4.99813 7.99003 5.07299C8.5006 4.96669 8.99962 4.81095 9.48003 4.60799C10.1222 4.34684 10.8122 4.22416 11.505 4.24799C12.1652 4.26452 12.8127 4.43287 13.3973 4.74C13.9818 5.04712 14.4879 5.48477 14.876 6.01899C14.3425 6.31815 13.887 6.73895 13.5466 7.24721C13.2063 7.75547 12.9906 8.33685 12.9171 8.94413C12.8437 9.55141 12.9145 10.1674 13.1238 10.7422C13.3332 11.317 13.6752 11.8342 14.122 12.252C14.4799 12.5943 14.8974 12.8682 15.354 13.06C15.2547 13.344 15.1497 13.6177 15.039 13.881ZM11.607 0.374992C11.5948 1.2951 11.249 2.1795 10.634 2.86399C10.3183 3.29497 9.90308 3.64326 9.42374 3.87919C8.9444 4.11512 8.41513 4.23169 7.88103 4.21899C7.86722 4.10718 7.86021 3.99464 7.86003 3.88199C7.89126 2.94701 8.25752 2.05442 8.89203 1.36699C9.24399 0.971763 9.67135 0.650818 10.149 0.422989C10.5962 0.192215 11.0852 0.0538019 11.587 0.0159912C11.5999 0.134216 11.6063 0.25306 11.606 0.371986L11.607 0.374992Z"
                            fill="currentColor" />
                    </svg>

                    Continuar con Apple
                </button>

                <hr>

                <p>Inicia sesión para gestionar tus transacciones de forma rápida y confiable.</p>
            }
        </div>
    }
}

